import { render, staticRenderFns } from "./SuperMenuCollectionRedirect.vue?vue&type=template&id=0d63df8e&"
import script from "./SuperMenuCollectionRedirect.vue?vue&type=script&lang=js&"
export * from "./SuperMenuCollectionRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports